"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapCountryCodeToName = exports.ctLocaleToEsShopMapper = exports.esToCtLocaleMapper = exports.ctToEsLocaleMapper = void 0;
const ct_1 = require("../ct");
const countryNameMapping_1 = require("./countryNameMapping");
const ctToEsLocale = {
    'en-gb': 'en_GB',
    'en-vg': 'en_GB',
    'en-gb-outlet': 'en_GB',
    'en-us': 'en_US',
    'en-ie': 'en_IE',
    'en-ca': 'en_CA',
    'fr-ca': 'fr_CA',
    'fr-fr': 'fr_FR',
    'de-de': 'de_DE',
    'es-es': 'es_ES',
    'it-it': 'it_IT',
    'nl-nl': 'nl_NL',
    'en-eu': 'en_EU',
};
function ctToEsLocaleMapper(ctLocale) {
    const locale = ctLocale.toLowerCase();
    return ctToEsLocale[locale] || 'en_EU';
}
exports.ctToEsLocaleMapper = ctToEsLocaleMapper;
const esToCtLocale = {
    en_gb: 'en-GB',
    en_us: 'en-US',
    en_ie: 'en-IE',
    en_ca: 'en-CA',
    fr_ca: 'fr-CA',
};
function esToCtLocaleMapper(esLocale) {
    const locale = esLocale.toLowerCase().replace('-', '_');
    return esToCtLocale[locale];
}
exports.esToCtLocaleMapper = esToCtLocaleMapper;
const ctLocaleToEsShop = {
    'en-gb': 'catalog-web-british-isles',
    'en-vg': 'catalog-web-british-isles',
    'en-gb-outlet': 'catalog-web-british-isles',
    'en-us': 'catalog-web-united-states',
    'en-ie': 'catalog-web-republic-of-ireland',
    'en-ca': 'catalog-web-canada',
    'fr-ca': 'catalog-web-canada',
};
function ctLocaleToEsShopMapper(ctLocale) {
    const locale = ctLocale.toLowerCase();
    let catalog = ctLocaleToEsShop[locale];
    if (!catalog && (0, ct_1.isStar2StoreLocale)(ctLocale)) {
        catalog = 'catalog-web-eu';
    }
    if (!catalog) {
        throw new Error(`Unable to determine NS catalog for locale=[${locale}]`);
    }
    return catalog;
}
exports.ctLocaleToEsShopMapper = ctLocaleToEsShopMapper;
function mapCountryCodeToName(countryCode) {
    const upperCode = countryCode?.toUpperCase();
    return upperCode ? countryNameMapping_1.countryCodeToCountryName[upperCode] : undefined;
}
exports.mapCountryCodeToName = mapCountryCodeToName;
//# sourceMappingURL=index.js.map